import styled from 'styled-components';

export const H1 = styled.h1`
  font-weight: var(--bold);
  font-size: var(--xx-large);
  line-height: 1.5em;
  letter-spacing: -0.25%;
`;

export const H2 = styled.h2`
  font-weight: var(--normal);
  font-size: var(--x-large);
  line-height: 1.5em;
  letter-spacing: 0;
`;

export const H3 = styled.h3`
  color: var(--text-primary);
  font-weight: var(--semi-bold);
  font-size: var(--large);
  line-height: 1.5em;
  letter-spacing: 0;
`;

export const H4 = styled.h4`
  font-weight: var(--semi-bold);
  font-size: 17px;
  line-height: 1.5em;
  letter-spacing: -0.25%;
`;

export const H5 = styled.h5`
  font-weight: var(--semi-bold);
  font-size: var(--small);
  line-height: 1.8em;
  letter-spacing: 5%;
  text-transform: uppercase;
`;
